if (module.hot) {
  module.hot.accept();
}


import $ from "jquery";
import CircleType from "circletype";




$( document ).ready(function() {
  // Handler for .ready() called.
  
  if($(window).width() < 800) {
    const circleThem = document.querySelectorAll('.spejas-list-item .curved-text');
    circleThem.forEach((el) => {
      new CircleType(el)
      .radius(30);
    });

    const circleThem2 = document.querySelectorAll('.spejas-list-item .curved-text-2');
    circleThem2.forEach((el) => {
      new CircleType(el)
      .radius(20).dir(-1);

      //circlegen.destroy.bind(circlegen);
    });

  } else {
    const circleThem = document.querySelectorAll('.spejas-list-item .curved-text');
    circleThem.forEach((el) => {
      new CircleType(el)
      .radius(50);
    });

    const circleThem2 = document.querySelectorAll('.spejas-list-item .curved-text-2');
    circleThem2.forEach((el) => {
      new CircleType(el)
      .radius(35).dir(-1);

      //circlegen.destroy.bind(circlegen);
    });

  }


  $('.spejas-list-item-under').hide();

  

  $('.spejas-list-item').click(function() {
    if(!$(this).hasClass('opened')) {
      $('.spejas-list-item').removeClass('opened');
      $(this).addClass('opened');
      $('.wysiwyg-preview').hide();

      $('.spejas-list-item .dashed-line').show();
      $(this).find('.dashed-line-first-level').hide();

      
    }
  });

  $('.spejas-list-item-under-list').click(function(e) {
    $('.wysiwyg-preview-header-type img').attr('src', $(this).find('img').attr('src'));
    $('.wysiwyg-preview').show();
    $('.wysiwyg-title').text($(this).find('img').attr('data-module-title'));

    $('.wysiwyg-preview-body').empty();
    //console.log(jsonData[$(this).find('img').attr('data-module-id')][$(this).find('img').attr('data-sub-module-id')].textdoc);
    $('.wysiwyg-preview-body').html(jsonData[$(this).find('img').attr('data-module-id')][$(this).find('img').attr('data-sub-module-id')].textdoc);
    var cursorX = e.pageX;
    var cursorY = e.pageY;

    console.log(cursorX, cursorY, $(window).width());

    $('.wysiwyg-preview').css('top', cursorY+60+'px');
    $('.wysiwyg-preview').css('left', cursorX+60+'px');

    if($(window).width() < 1400) {
      $('.wysiwyg-preview').css('top', cursorY+60+'px');
      $('.wysiwyg-preview').css('left', cursorX-160+'px');
    }

    //if(cursorX > 1000) {
    if(cursorX > ($(window).width()/2)) {
      $('.wysiwyg-preview').css('left', cursorX-500+'px');
    }

    if($(window).width() < 800) {
      $('.wysiwyg-preview').css('top', 50+'%');
      $('.wysiwyg-preview').css('left', 50+'%');
    }



    $('.spejas-list-item .dashed-line').show();
    $(this).parents('.spejas-list-item').find('.dashed-line-first-level').hide();


  });

  $('.wysiwyg-preview-close').click(function() {
    $('.wysiwyg-preview').hide();
  });
});